import { useState } from "react";
import { FiMessageSquare, FiPhone, FiX } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingContactWidget.css";

const PHONE_LINK = "tel:+919158914222";
const PHONE_TEXT = "+91 91589 14222";
const QUOTE_LINK = "/contact";
const WHATSAPP_LINK = "https://wa.me/919158914222";

export default function FloatingContactWidget() {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const handleToggleClick = (e) => {
    const isMobile = window.matchMedia("(max-width: 640px)").matches;
    if (isMobile) {
      e.preventDefault();
      setIsPanelOpen((prev) => !prev);
    }
  };

  return (
    <aside
      className={`floating-contact-widget ${isPanelOpen ? "floating-contact-widget--panel-open" : ""}`}
      aria-label="Contact Dwellora"
    >
      <div className="floating-contact-panel" aria-label="Contact options">
        <a
          className="floating-contact-item floating-contact-item--whatsapp"
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <span className="floating-contact-label">Chat with us</span>
          <span className="floating-contact-item-icon">
            <FaWhatsapp />
          </span>
        </a>
        <a
          className="floating-contact-item floating-contact-item--call"
          href={PHONE_LINK}
          aria-label={`Call us at ${PHONE_TEXT}`}
          data-phone={PHONE_TEXT}
        >
          <span className="floating-contact-label">
            <span className="floating-contact-label-mobile">Call Us Now</span>
            <span className="floating-contact-label-desktop">{PHONE_TEXT}</span>
          </span>
          <span className="floating-contact-item-icon">
            <FiPhone />
          </span>
        </a>
      </div>

      <a
        className="floating-contact-toggle"
        href={QUOTE_LINK}
        aria-label="Get in touch"
        onClick={handleToggleClick}
      >
        <span>Get in Touch</span>
        <span className="floating-contact-icon" aria-hidden="true">
          <FiPhone className="floating-contact-phone-icon" />
          <FiMessageSquare className="floating-contact-message-icon" />
          <FiX />
        </span>
      </a>

      {/* <div className="floating-contact-mobile-actions">
        <a className="floating-contact-call-action" href={PHONE_LINK}>
          <FiPhone aria-hidden="true" />
          <span>Call Now</span>
        </a>
        <a className="floating-contact-quote-action" href={QUOTE_LINK}>
          Get a Free Quote
        </a>
      </div> */}
    </aside>
  );
}
